// extracted by mini-css-extract-plugin
export default {"card":"D7-z"};